import React from 'react';
import cc from 'classcat';
import { observer } from 'mobx-react-lite';
import { If, Then } from 'react-if';
import styles from './table.module.sass';
import { SkeletonTable } from '../../Skeleton/SkeletonTable';
import { useAuthStore } from '../../../providers/RootStoreProvider';
import { Icon } from '../../Icon';
import { IconSVG } from '../../SpriteSVG';

export const Table = observer(
  ({ view, className, grid, headers, items, loading, transfer, isMobile }) => {
    // Helper для передачи grid разметки во все <tr>
    const Tr = ({ children, ...props }) => (
      <tr style={{ gridTemplateColumns: grid }} {...props}>
        {children}
      </tr>
    );

    const authStore = useAuthStore();

    return (
      <table
        className={cc([
          styles.table,
          styles[view],
          { [className]: !!className },
        ])}
      >
        <thead className={styles.head}>
          <Tr>
            {headers?.map(({ title, note }) =>
              title !== 'id' ? (
                <th key={title}>
                  {title}
                  <div className={styles.subtitle}>{note}</div>
                </th>
              ) : null,
            )}
            {authStore.isManager && <th />}
          </Tr>
        </thead>
        <tbody className={styles.body}>
          {loading && (
            <div className={styles.skeletons}>
              {new Array(10).fill(null).map((_, idx) => (
                <SkeletonTable key={idx} />
              ))}
            </div>
          )}
          {!loading &&
            items &&
            items.length > 0 &&
            items.map((i, idx) => (
              <Tr key={idx}>
                {i.map((j, id) => (
                  <td key={`${j}_${idx}`} className={styles.between}>
                    {j !== 0 && (
                      <div className={styles.tableRow}>
                        <If condition={j !== i[4]}>
                          <Then>{j || '—'}</Then>
                        </If>
                        {transfer[idx][id] !== 0 && transfer[idx][4] !== 0 && (
                          <div className={styles.tableTransfer}>
                            <If
                              condition={j !== i[4] && transfer[idx][4] !== 0}
                            >
                              <Then>{transfer[idx][id]}</Then>
                            </If>
                          </div>
                        )}
                      </div>
                    )}

                    <If condition={j === i[4] && j !== 0}>
                      <Then>
                        {authStore.isManager && (
                          <a
                            href={`/adm_n/index.html#!/cruises/${i[4]}`}
                            className={styles.button}
                            rel="noreferrer"
                          >
                            <Icon
                              icon={
                                <IconSVG
                                  name={'common/edit'}
                                  width={16}
                                  height={16}
                                />
                              }
                              width={16}
                              height={16}
                            />
                          </a>
                        )}
                      </Then>
                    </If>
                  </td>
                ))}
              </Tr>
            ))}
        </tbody>
      </table>
    );
  },
);

Table.defaultProps = {
  view: 'main',
};
